<template>
  <f7-page class="setting-page-wrap page">
    <template v-if="backKey===true">
      

      
      <f7-navbar >
        <f7-nav-left style="padding-left:15px;">
           <i class="icon icon-back" @click="backIndex()" ></i>
        </f7-nav-left>
      </f7-navbar>
    </template>
    <template v-else>
      <f7-navbar   >
        <div style="width:100%;text-align:center;">
                 　
        </div>
      </f7-navbar>
    </template>
    <header class="wave-header sticky-top">
      <div class="header-avatar">
        <template v-if="localAavatarPath === ''">
          <input type="file" id="uploadAvatar" value="" @change="fileChange" accept="image/gif,image/jpeg,image/jpg,image/png"/>
          <label for="uploadAvatar">
            <i class="material-icons">photo_camera</i>
          </label>
        </template>
        <template v-else >
          <input type="file" id="uploadAvatar" value="" @change="fileChange" accept="image/gif,image/jpeg,image/jpg,image/png"/>
          <label for="uploadAvatar" class="image-cover" v-bind:style="{'background-image':'url('+ localAavatarPath+')'}">
            <i class="material-icons">photo_camera</i>
          </label>
        </template>
        <!--loading -->
        
          <div :style= "{'display': blockFlag }" >
            <div class="uploading"><div class="preloader color-multi"></div></div>
          </div>
      </div>
      <h2>{{ userName }}</h2>
    </header>
    <settings-basic></settings-basic>
  </f7-page>
</template>



<script>
import Service from "../../service";
import BasicPage from './settings-basic.vue'
import axios from '../../js/axiosModule.js';
import { bus } from '../../js/bus.js';

var moment = require('moment');
export default {
  components: {
      'settings-basic':BasicPage,
  },
  data() {
    return {
      userName :this.$store.state.userInfo.chineseName,
      dish: Service.getDish(this.$f7route.params.id),
      isBaisc:true,
      backKey:this.$f7route.query.back === undefined ? true : false,
      isImageUploading: true,
      avatarPath : "",
      localAavatarPath:(this.$store.state.userInfo.avatarPath !== undefined && this.$store.state.userInfo.avatarPath.length > 0) ? this.$app.cdnUrl + "/" + this.$store.state.userInfo.avatarPath : '',
      file:null,
      blockFlag : "none"
    };
  },
  methods: {
    fileChange :function(e) {
      let self = this;
      self.isImageUploading = false;
      self.blockFlag = "block";
      
      self.file = e.target.files[0];
      this.formData = new FormData();
      this.formData.append("file", self.file);
      self.upload();
    },
    upload:function() {
      let self = this;
      self.blockFlag = "block";
      if (self.formData.get("file") != null && self.formData.get("file") != undefined) {
        let config = {
          header : {
            'Content-Type' : 'multipart/form-data'
          }
        }

        axios.axiosTokenPost(self.$app.axiosUrl+"/api/File/UploadFile",self.formData,config).then((response)=> {
          
          self.localAavatarPath = self.$app.cdnUrl +'/'+ response.data.data;
          self.avatarPath = response.data.data;
          self.setStudent();
          
        }).catch(err=>function() {
          if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
            self.$f7router.navigate("/login");
          } 
        });
      } else {
        alert("請選擇圖片！");
      }
      
    },
    setStudent : function() {
      let self = this;
      var params = {};
      params.studentNo = self.$store.state.userInfo.studentNo;
      params.avatarPath = self.avatarPath;
      params.createdBy = self.$store.state.userInfo.studentNo;
      params.createdAt = self.getNowTime();
      params.updatedBy = self.$store.state.userInfo.studentNo;
      params.updatedAt = self.getNowTime();
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Student/SetStudent",params).then((response) => {
          let userData = self.$store.state.userInfo;
          userData.avatarPath = self.avatarPath;
          self.$store.dispatch("userTrigger", userData);
          self.blockFlag = "none";
          self.isImageUploading=true;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
          self.$f7router.navigate("/login");
        } 
      });

    },
     getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;
      return dateTime;
    },
    backIndex : function() {
      let self = this;
      return new Promise((resolve,reject) => {
        self.$f7router.navigate("/");
        setTimeout(
          function() {
            bus.$emit('homeBus',{"avatarPath":self.localAavatarPath});
          }
        ,100);
      });
      
    }
  },
  mounted() {

          this.blockFlag = "none";
  },
  created() {
          this.blockFlag = "none";
  },computed: {
    
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/users/settings.vue